import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import htmlDecode from '../helper/htmlDecode';
import Paper from '../Paper/Paper';
const FieldsetRoot = styled(Box, {
    name: 'Fieldset',
    slot: 'root',
})(() => ({}));
const FieldsetTitle = styled('p', {
    name: 'Fieldset',
    slot: 'title',
})(({ theme }) => ({
    fontSize: '18px',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    marginBottom: '5px',
}));
export default function Fieldset(props) {
    const { title, fields = [], } = props;
    let { children } = props;
    if (children && !Array.isArray(children)) {
        children = [children];
    }
    return (_jsxs(FieldsetRoot, { className: clsx(props === null || props === void 0 ? void 0 : props.className, 'Fieldset-root'), children: [_jsx(FieldsetTitle, { className: "Fieldset-title", children: htmlDecode(title) }), _jsx(Paper, { children: (children || fields || []).map((field, index) => (_jsx(Box, { children: field }, index))) })] }));
}
